.vr {
  display: inline-block;
  align-self: stretch;
  width: $vr-border-width;
  min-height: 1em;
  background-color: currentcolor;
  opacity: $hr-opacity;
}
